import React from 'react';
import { Shape, LazyImage, SubTitle } from '@teko/ds-desktop';
import noProductsFoundImage from '../../assets/images/no-products-found.es.js';
import { t } from '../../i18n.es.js';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const NoProductsFound = (_a) => {
  var _b = _a, {
    text,
    show
  } = _b, props = __objRest(_b, [
    "text",
    "show"
  ]);
  text = text || t("Kh\xF4ng t\xECm th\u1EA5y s\u1EA3n ph\u1EA9m n\xE0o");
  if (!show)
    return null;
  return /* @__PURE__ */ React.createElement(Shape, __spreadProps(__spreadValues({
    marginTop: "s40",
    marginBottom: "s40",
    style: { textAlign: "center" }
  }, props), {
    className: "att-no-products-found"
  }), /* @__PURE__ */ React.createElement(LazyImage, {
    width: 200,
    height: 200,
    contain: true,
    src: noProductsFoundImage
  }), /* @__PURE__ */ React.createElement(SubTitle, {
    level: 2,
    marginTop: "s24"
  }, text));
};

export { NoProductsFound };
